<template>
<b-modal ref='modal' @ok="save" hide-header centered>
  <div v-if='email'>
    <b-input v-model="subject" placeholder="Subject line (Leave blank to continue thread)" type="text" class="mb-2" />
    <b-dropdown text="Insert variable" class="mb-2">
      <b-dropdown-item v-for="(insert_option, $index) in insert_options" :key="$index" @click="insert_variable(insert_option.value)">{{insert_option.name}}</b-dropdown-item>
    </b-dropdown>

    <div class="editor mb-2">
      <editor-menu-bubble :editor="editor" v-slot="{ commands, isActive, menu, getMarkAttrs }" @hide="hideLinkMenu">
        <div class="menububble" :class="{ 'is-active': menu.isActive }" :style="`left: ${menu.left}px; bottom: ${menu.bottom}px;`">
          <!-- <div class="menububble" > -->
          <form class="menububble__form" v-if="linkMenuIsActive" @submit.prevent="setLinkUrl(commands.link, linkUrl)">
            <input class="menububble__input" type="text" v-model="linkUrl" placeholder="https://" ref="linkInput" @keydown.esc="hideLinkMenu" />
            <button class="menububble__button" @click="setLinkUrl(commands.link, null)" type="button">
              <i class="fas fa-times-circle"></i>
            </button>
          </form>
          <!-- </div> -->
          <div v-else>
            <button class="menubar__button" :class="{ 'is-active': isActive.link() }" @click="showLinkMenu(getMarkAttrs('link'))"><i class="fas fa-link"></i></button>
            <button class="menubar__button" :class="{ 'is-active': isActive.bold() }" @click="commands.bold"><i class="fas fa-bold"></i></button>
            <button class="menubar__button" :class="{ 'is-active': isActive.italic() }" @click="commands.italic"><i class="fas fa-italic"></i></button>
          </div>
        </div>
      </editor-menu-bubble>

      <editor-content class="editor__content" :editor="editor" />
    </div>
  </div>

  <b-form-group label='Delay (days)' description='Number of days to delay email after previous action' label-cols="3">
    <b-input v-model="days_delay" min="0" max="30" type="number" class="mb-2"/>
  </b-form-group>
</b-modal>
</template>


<script>
import {
  Editor,
  EditorContent,
  EditorMenuBar,
  EditorFloatingMenu,
  EditorMenuBubble
} from 'tiptap'
import {
  Blockquote,
  BulletList,
  HardBreak,
  Heading,
  ListItem,
  OrderedList,
  Bold,
  Italic,
  Link,
  History,
  Image
} from 'tiptap-extensions'

import { db } from '@/main.js'

export default {
  props: ['sequence', 'profile', 'create', 'email', 'on_complete', 'requires_subject', 'projects'],
  components: {
    EditorContent,
    EditorMenuBubble
  },
  data() {
    return {
      // email: null,
      subject: '',
      message: '',
      days_delay: 0,
      editor: null,
      linkUrl: null,
      linkMenuIsActive: false,
    }
  },
  beforeDestroy() {
    this.editor.destroy()
  },
  mounted() {
    this.editor = new Editor({
      // onUpdate: this.editor_update,
      autoFocus: true,
      extensions: [
        // new Blockquote(),
        // new BulletList(),
        // new HardBreak(),
        // new ListItem(),
        // new OrderedList(),
        new Link(),
        new Bold(),
        new Italic(),
        new History(),
      ],
      content: this.item ? this.item.content : '',
    })
  },
  computed: {
    insert_options() {
      let insert_options = [{name: 'First name', value: 'first_name'}, {name: 'Organisation', value: 'organisation'}, {name: 'Custom 1', value: 'custom_1'}, {name: 'Custom 2', value: 'custom_2'}, {name: 'Custom 3', value: 'custom_3'}, {name: 'Custom 4', value: 'custom_4'}, {name: 'Unsubscribe link', value: 'unsubscribe_link'}]
      for (let project of this.projects) {
        insert_options.push({name: `VIDEO: ${project.name}`, value: `VIDEO_${project.id}`})
      }

      return insert_options
    }
  },
  methods: {
    variables_are_valid(html) {
      let allowed_variables = []
      for (let variable of this.insert_options) {
        allowed_variables.push(variable.value)
      }
      let variables = html.match(/{{{(.+?)}}}/g)
      if (!variables) {
        return true
      }

      for (let _variable of variables) {
        let variable = _variable.replace('{{{', '').replace('}}}', '')
        if (allowed_variables.indexOf(variable) === -1) {
          return variable
        }
      }

      return true
    },
    showLinkMenu(attrs) {
      this.linkUrl = attrs.href
      this.linkMenuIsActive = true
      this.$nextTick(() => {
        this.$refs.linkInput.focus()
      })
    },
    hideLinkMenu() {
      this.linkUrl = null
      this.linkMenuIsActive = false
    },
    setLinkUrl(command, url) {
      command({
        href: url
      })
      this.hideLinkMenu()
    },
    insert_variable(variable) {
      let html = this.editor.getHTML()
      html = html.replace(/<\/p>$/, `{{{${variable}}}}</p>`)
      this.editor.setContent(html)
    },
    async save(bvModalEvt) {
      bvModalEvt.preventDefault()

      let html = this.editor.getHTML()

      if (this.requires_subject && this.subject.length == 0) {
        return this.$swal({title: 'Subject required', text: "A subject line is required", icon: 'warning'})
      }

      if (html.length == 0) {
        return this.$swal({title: 'Message required', text: "A message is required", icon: 'warning'})
      }

      // TODO MAX days
      if (this.days_delay < 0 || this.days_delay > 30) {
        return this.$swal({title: 'Invalid delay', text: "Days delayed must be between 0 and 30 days", icon: 'warning'})
      }

      let variables_are_valid = this.variables_are_valid(html)
      if (variables_are_valid !== true) {
          return this.$swal({title: 'Invalid variables', text: `An invalid variable was found, pleas remove: ${variables_are_valid}`, icon: 'warning'})
      }

      this.email.subject = this.subject
      this.email.body = html
      this.email.days_delay = this.days_delay

      if (!this.create) {
        console.log(this.email)
        await db.collection('sequence').doc(this.sequence.id).collection('step').doc(this.email.id).update({updated: new Date(), subject: this.subject, body: html, days_delay: this.days_delay})
      }

      if (this.on_complete) {
        this.on_complete()
      }
      this.hide()
    },
    show() {
      this.subject = this.email.subject || ''
      this.message = this.email.body
      this.days_delay = this.email.days_delay
      this.editor.setContent(this.message)
      this.$refs.modal.show()
    },
    hide() {
      this.$nextTick(() => {
        this.$refs.modal.hide()
      })
    }
  }
}
</script>


<style lang="scss">
strong, .strong {
    font-weight: bold !important;
}

$color-black: #000000;
$color-white: #ffffff;
$color-grey: #dddddd;

.ProseMirror {
    color: #4D484A;
    font-size: 16px;
    font-weight: 200;
    line-height: 22px;
    // height: 200px;
    min-height: 200px;
}

.editor__content p {
    margin: 0;
    color: #222 !important;
}

.editor {
    position: relative;
    // margin-bottom: 140px !important;
    font-size: 16px !important;
    &__floating-menu {
        position: absolute;
        z-index: 1;
        margin-top: -0.25rem;
        visibility: hidden;
        opacity: 0;
        transition: opacity 0.2s, visibility 0.2s;
        &.is-active {
            opacity: 1;
            visibility: visible;
        }
    }
}

.menubar__button {
    color: #FFF !important;
}

.editor__floating-menu > .menubar__button {
    opacity: 0.25;
}

.menubar {

    margin-bottom: 1rem;
    transition: visibility 0.2s 0.4s, opacity 0.2s 0.4s;

    &.is-hidden {
        visibility: hidden;
        opacity: 0;
    }

    &.is-focused {
        visibility: visible;
        opacity: 1;
        transition: visibility 0.2s, opacity 0.2s;
    }

    &__button {
        font-weight: bold;
        display: inline-flex;
        background: transparent;
        border: 0;
        color: $color-black;
        padding: 0.2rem 0.5rem;
        margin-right: 0.2rem;
        border-radius: 3px;
        cursor: pointer;

        &:hover {
            background-color: rgba($color-black, 0.05);
        }

        &.is-active {
            background-color: rgba($color-black, 0.1);
        }
    }

    span#{ &}__button {
        font-size: 13.3333px;
    }
}

// .menububble__form {
//   position: absolute;
//   display: flex;
//   z-index: 20;
//   background: $color-black;
//   border-radius: 5px;
//   padding: 0.3rem;
//   margin-bottom: 0.5rem;
//   transform: translateX(-50%);
//   // transform: translateY(100%);
//   // visibility: hidden;
//   // opacity: 0;
//   transition: opacity 0.2s, visibility 0.2s;
// }

.menububble {
    position: absolute;
    display: flex;
    z-index: 20;
    background: $color-black;
    border-radius: 5px;
    padding: 0.3rem;
    margin-bottom: 0.5rem;
    transform: translateX(-50%);
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.2s, visibility 0.2s;

    &.is-active {
        opacity: 1;
        visibility: visible;
    }

    &__button {
        display: inline-flex;
        background: transparent;
        border: 0;
        color: $color-white;
        padding: 0.2rem 0.5rem;
        margin-right: 0.2rem;
        border-radius: 3px;
        cursor: pointer;

        &:last-child {
            margin-right: 0;
        }

        &:hover {
            background-color: rgba($color-white, 0.1);
        }

        &.is-active {
            background-color: rgba($color-white, 0.2);
        }
    }

    &__form {
        display: flex;
        align-items: center;
    }

    &__input {
        font: inherit;
        border: none;
        background: transparent;
        color: $color-white;
    }
}

.message {
    background-color: rgba($color-black, 0.05);
    color: rgba($color-black, 0.7);
    padding: 1rem;
    border-radius: 6px;
    margin-bottom: 1.5rem;
    font-style: italic;
}

.editor__content > div {
    outline: none;
}

.editor {
    position: relative;
    margin: 0 auto;
    border: 1px solid #ced4db;
    border-radius: 4px;
    padding: 1em;

    &__content {

        overflow-wrap: break-word;
        word-wrap: break-word;
        word-break: break-word;

        * {
            caret-color: currentColor;
        }

        pre {
            padding: 0.7rem 1rem;
            border-radius: 5px;
            background: $color-black;
            color: $color-white;
            font-size: 0.8rem;
            overflow-x: auto;

            code {
                display: block;
            }
        }

        p code {
            padding: 0.2rem 0.4rem;
            border-radius: 5px;
            font-size: 0.8rem;
            font-weight: bold;
            background: rgba($color-black, 0.1);
            color: rgba($color-black, 0.8);
        }

        ol,
        ul {
            padding-left: 1rem;
        }

        li > ol,
        li > p,
        li > ul {
            margin: 0;
        }

        a {
            color: inherit;
        }

        blockquote {
            border-left: 3px solid rgba($color-black, 0.1);
            color: rgba($color-black, 0.8);
            padding-left: 0.8rem;
            font-style: italic;

            p {
                margin: 0;
            }
        }

        img {
            max-width: 100%;
            border-radius: 3px;
        }

        table {
            border-collapse: collapse;
            table-layout: fixed;
            width: 100%;
            margin: 0;
            overflow: hidden;

            td,
            th {
                min-width: 1em;
                border: 2px solid $color-grey;
                padding: 3px 5px;
                vertical-align: top;
                box-sizing: border-box;
                position: relative;
                > * {
                    margin-bottom: 0;
                }
            }

            th {
                font-weight: bold;
                text-align: left;
            }

            .selectedCell:after {
                z-index: 2;
                position: absolute;
                content: "";
                left: 0;
                right: 0;
                top: 0;
                bottom: 0;
                background: rgba(200, 200, 255, 0.4);
                pointer-events: none;
            }

            .column-resize-handle {
                position: absolute;
                right: -2px;
                top: 0;
                bottom: 0;
                width: 4px;
                z-index: 20;
                background-color: #adf;
                pointer-events: none;
            }
        }

        .tableWrapper {
            margin: 1em 0;
            overflow-x: auto;
        }

        .resize-cursor {
            cursor: ew-resize;
            cursor: col-resize;
        }

    }
}

.menububble__form {
    display: -webkit-box;
    display: -ms-flexbox;
    // display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}

.menububble__input {
    font: inherit;
    border: none;
    background: transparent;
    color: #fff;
}

.menububble__button {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    background: transparent;
    border: 0;
    color: #fff;
    padding: 0.2rem 0.5rem;
    margin-right: 0.2rem;
    border-radius: 3px;
    cursor: pointer;
}
</style>
